import { ReactComponent as UrbaneaseLogo } from '../../images/urbaneaseIcon.svg';

import { useAppDispatch, useAppSelector } from '../../App/redux/store';
import { getModalsState, modalsActions } from '../../features/modals/modalsSlice';
import styles from './linksToUrbanease.module.scss';
import { getUrbaneaseAuthentication } from './utils';

function LinkFromMenu() {
  const { mobileNav } = useAppSelector(getModalsState);
  const dispatch = useAppDispatch();

  const handleClick = async () => {
    if (mobileNav) {
      dispatch(modalsActions.mobileNav(false));
    }
    try {
      await getUrbaneaseAuthentication();
    } catch (error: any) {
      if (error?.status) {
        dispatch(modalsActions.noUrbaneaseAccount({ error: error.status }));
      }
    }
  };

  return (
    <li className={styles.linkFromMenu} onClick={handleClick}>
      <UrbaneaseLogo className={styles.logo} />
      <span>Carte Urbanease</span>
    </li>
  );
}

export default LinkFromMenu;
